// extracted by mini-css-extract-plugin
export default {"base":"TourBase_base__MpRz4"};